import React, {Fragment, useState, useEffect} from 'react';

//components
import CategoryCard from './CategoryCard';
import ServicesSearch from '../services/ServicesSearch';

import Loader from 'react-loader-spinner';

const CategoryCardContent = () => {

  const [specialCategories] = useState([
    {
      value: 'Cooperativas',
      name: 'Cooperativas',
      id: 'cooperative'
    },
    {
      value: 'Pymes lideradas por mujeres',
      name: 'Pymes lideradas por mujeres',
      id: 'womanPyme'
    }
  ]);

  const [categories, setCategories] = useState([]);
  const [loader, setLoader] = useState(true);

  const getData = () => {
    ServicesSearch.getDataCategories()
      .then(response => {
        setCategories(response.data['Categorias'].options);
        setLoader(false);
      })
      .catch(e => {
        setLoader(false);
        console.log(e);
      });
  };

  useEffect(getData, []);

  return (
    <Fragment>
      <div className="row justify-content-center">
      <div className="col-md-12 mt-5 mb-3">
        <h3>Categorías especiales</h3>
      </div>
      {
        specialCategories.map((category, index) => (
          <div
            className="col-lg-4 m-b-35"
            key={index}
            >
            <CategoryCard
              categoryData={category}
              type={'special'}
            />
          </div>
        ))
      }
      </div>

      <div className="row">
        <div className="col-md-12 mb-3">
          <h3>Busca por categoría</h3>
        </div>
      {
        loader ?
          <div className="spinner-d">
           <Loader
             type="Oval"
             color="#00BFFF"
             height={50}
             width={50}
             className="spinner-1"
           />
          </div>
          :
          categories.map((category, index) => (
            <div
              className="col-lg-3 m-b-35"
              key={index}
              >
              <CategoryCard
                categoryData={category}
                type={'normal'}
              />
            </div>
          ))
      }
      </div>
    </Fragment>
  );
};

export default CategoryCardContent;
